import { captionClassName, pxArrayToRem, pxToRem } from '@archipro-design/aria';
import type { StyleRule } from '@archipro-design/aria';

export const NoPinsTile: StyleRule = ({ theme }) => ({
    [theme.screen.tablet]: {
        position: 'absolute',
        zIndex: 1,
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        justifyContent: 'center',
        background: '#DDDDDD', // can't find it in aria
        width: pxToRem(364),
        height: pxToRem(240),
    },
});

export const NoBoardState: StyleRule = ({ theme }) => ({
    padding: pxArrayToRem([32, 18, 0]),
    [`& .${captionClassName}`]: {
        fontSize: pxToRem(16),
        width: pxToRem(378),
        margin: 0,
        lineHeight: pxToRem(22.4),
        color: theme.siteVariables.colors.charcoal[250],
        ':first-child': {
            marginBottom: pxToRem(22),
        },
        '& span': {
            display: 'block',
        },
    },

    [theme.screen.tablet]: {
        padding: 0,
        margin: pxArrayToRem([50, 50, 0, 50]),
        [`& .${captionClassName}`]: {
            fontSize: pxToRem(16),
            width: pxToRem(1185),
            margin: 0,
            lineHeight: pxToRem(22),
            color: theme.siteVariables.colors.charcoal[250],
            ':first-child': {
                marginBottom: 'unset',
            },
            '& span': {
                display: 'inline-block',
            },
        },
    },
});

export const NoBoardStateContent: StyleRule = ({ theme }) => ({
    marginBottom: pxToRem(32),
    [theme.screen.tablet]: {
        marginBottom: 0,
    },
});

export const NoPinState: StyleRule = ({ theme }) => ({
    margin: pxArrayToRem([32, 0, 0, 18]),
    [`& .${captionClassName}`]: {
        fontSize: pxToRem(16),
        width: pxToRem(370),
        margin: 0,
        lineHeight: pxToRem(22.4),
        color: theme.siteVariables.colors.charcoal[250],
        '& > div': {
            marginTop: pxToRem(21.5),
        },
    },

    [theme.screen.tablet]: {
        margin: pxArrayToRem([50, 50, 0, 50]),
        [`& .${captionClassName}`]: {
            fontSize: pxToRem(16),
            width: pxToRem(1185),
            margin: 0,
            lineHeight: pxToRem(22),
            color: theme.siteVariables.colors.charcoal[250],
            '& > div': {
                marginTop: 'unset',
            },
        },
    },
});

export const NoPinStateContent: StyleRule = ({ theme }) => ({
    marginBottom: pxToRem(32),
    [theme.screen.tablet]: {
        marginBottom: 0,
    },
});

export const CallToActionContainer: StyleRule = () => ({
    marginTop: pxToRem(230),
});
